import type { CommunityDetail } from '@pba/react-network';
import { ChannelsDetailCard } from 'features/channels';
import { CommunityDetailsCard } from '../community-details-card';
import { CommunityMembersCard } from '../community-members-card';

type P = {
  community: CommunityDetail;
};

const CommunitySideCards = ({ community }: P) => (
  <>
    <CommunityMembersCard community={community} />
    <CommunityDetailsCard community={community} />
    <ChannelsDetailCard
      channelAppearance={{ featured: community.featuredInChannels }}
      channelTags={community.tags}
      organizationId={community.organization.id}
    />
  </>
);

export default CommunitySideCards;
